export default "__VITE_ASSET__CDBAEx6w__"